/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeammateHealthAvatar_person = {
    readonly id: string;
    readonly emails: ReadonlyArray<string>;
    readonly primaryEmail: string;
    readonly isYou: boolean;
    readonly userId: string | null;
    readonly isUser: boolean;
    readonly profile: {
        readonly givenName: string | null;
        readonly familyName: string | null;
        readonly externalImageUrl: string | null;
    } | null;
    readonly __typename: "Person";
    readonly " $refType": "TeammateHealthAvatar_person";
};
export type TeammateHealthAvatar_person$data = TeammateHealthAvatar_person;
export type TeammateHealthAvatar_person$key = {
    readonly " $data"?: TeammateHealthAvatar_person$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeammateHealthAvatar_person">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeammateHealthAvatar_person",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emails",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryEmail",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isYou",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isUser",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "givenName",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "familyName",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalImageUrl",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Person",
    "abstractKey": null
} as any;
(node as any).hash = '16b492e70b559a4587fb45fb75d0e367';
export default node;
